(function () {
  const Core = window.RB.Core;
  const { buff } = window.RB.CardLib;
  const { hasPrintedOrGrantedKw } = window.RB.CardLib.unl;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Buff": {},

    "XP Tracker": {},

    "Amateur Recital": {
      triggers: [
        {
          on: "hold",
          selfBf: true,
          you: true,
          label: "when you hold here",
          targets: [],
          program: [
            {
              op: "may",
              prompt: "You may move a unit at a battlefield to its base?",
              then: [
                { op: "choose", bind: "t1", spec: { type: "unit", atBf: true }, prompt: "Move..." },
                { op: "move", to: "$t1", dest: "base" },
              ],
            },
          ],
        },
      ],
    },

    "Black Flame Altar": {
      auraKw: function (state, src, target) {
        const o = state.objs[target];
        if (!o || o.zone !== "board") return [];
        if (!o.loc || o.loc.t !== "bf" || o.loc.iid !== src) return [];
        if (!Core.isType(state, target, "unit")) return [];
        return hasPrintedOrGrantedKw(state, target, "temporary") ? [["shield", 1]] : [];
      },
    },

    "Forbidding Waste": {
      auraMightSpecs: [{
        n: -2, who: "all", scope: "atSource",
        targetCond: { k: "and", conds: [{ k: "selfDefending" }, { k: "aloneHere" }] },
      }],
    },

    "Forgotten Library": {
      triggers: [{
        on: "finalizedCard", you: true, label: "library predict",
        condSpec: {
          k: "and", conds: [
            { k: "evType", type: "spell" },
            { k: "turnFact", key: "lastSpellEnergy", n: 4 },
          ],
        },
        targets: [],
        program: [{ op: "predict", n: 1 }],
      }],
    },

    "Frozen Fortress": {
      triggers: [{
        on: "beginningPhase", label: "frostbite",
        targets: [],
        program: [{ op: "deal", spec: { type: "unit", ignoreUntargetable: true }, at: "source", n: 1 }],
      }],
    },

    "Gardens of Becoming": {
      auraAbilities: [{
        who: "all", what: { type: "unit" }, scope: "atSource",
        ability: {
          label: "Exhaust: gain 1 XP", exhausts: true, targets: [],
          program: [{ op: "xp", n: 1 }],
        },
      }],
    },

    "Ripper's Bay": {
      triggers: [{
        on: "toHand", label: "bay tithe", controllerFromEvent: true,
        condSpec: { k: "and", conds: [{ k: "evFromSelfBf" }, { k: "evType", type: "unit" }] },
        targets: [],
        program: [{
          op: "may", prompt: "Pay 1 Energy to channel 1 rune exhausted?", then: [
            { op: "payCost", cost: { energy: 1, pips: 0, anyPower: 0, domains: null }, varKey: "bay", skipOnFail: 1 },
            { op: "channel", n: 1, exhausted: true },
          ],
        }],
      }],
    },

    "Valley of Idols": {
      triggers: [{
        on: "played", label: "idol tribute", controllerFromEvent: true,
        condSpec: { k: "evType", type: "unit" },
        cond: function (state, iid, ev) {
          return !!(ev.loc && ev.loc.t === "bf" && ev.loc.iid === iid);
        },
        targets: [],
        program: [{
          op: "may", prompt: "Pay 1 Energy to Buff the unit played here?", then: [
            { op: "payCost", cost: { energy: 1, pips: 0, anyPower: 0, domains: null }, varKey: "idol", skipOnFail: 1 },
            { op: "buff", to: "$ev" },
          ],
        }],
      }],
    },

    "Trapping Grounds": {
      triggers: [{
        on: "conquer", selfBf: true, you: true, label: "trapped bird",
        condSpec: { k: "excessDamageAtLeast", n: 3 },
        targets: [],
        program: [{ op: "token", name: "Bird", loc: "here" }],
      }],
    },

    "Brush": {
      auraMightSpecs: [{
        n: 1, who: "all", scope: "atSource",
        targetCond: {
          k: "or", conds: [
            { k: "selfTag", tag: "Bird" },
            { k: "selfTag", tag: "Cat" },
            { k: "selfTag", tag: "Dog" },
            { k: "selfTag", tag: "Poro" },
            { k: "selfTag", tag: "Ivern" },
          ],
        },
      }],
      triggers: [
        {
          on: "conquer", selfBf: true, you: true, optional: true, onceKey: "brushSwapBack",
          label: "scored here: put the battlefield it replaced back",
          program: [{ op: "restoreBf" }],
        },
        {
          on: "hold", selfBf: true, you: true, optional: true, onceKey: "brushSwapBack",
          label: "scored here: put the battlefield it replaced back",
          program: [{ op: "restoreBf" }],
        },
      ],
    },

    "Baron Pit": {
      allowMoveHere: true,
    },

    "Altar of Blood": {
      staticDeathReplace: {
        who: "all", scope: "atSource", inCombat: true,
        payer: "controller", cost: { anyPower: 3 },
        label: "Altar of Blood",
      },
    },

    "The Academy": {
      triggers: [{
        on: "hold", selfBf: true, you: true,
        label: "hold here: your next spell this turn gets [Repeat] equal to its base cost",
        program: [{ op: "nextPlayMod", mod: "grantRepeat", cardType: "spell", repeatOf: "base" }],
      }],
    },

    "Abandoned Hall": {
      triggers: [{
        on: "finalizedCard", controllerFromEvent: true, optional: true,
        label: "a spell was played: give a unit here +1 Might this turn",
        condSpec: { k: "evType", type: "spell" },
        targets: [{
          bind: "t", spec: { type: "unit", friendly: true, here: true },
          prompt: "Give which of your units here +1 Might this turn?",
        }],
        program: [buff("$t", 1)],
      }],
    },

    "Dusk Rose Lab": {
      triggers: [{
        on: "beginningPhase", you: true, optional: true,
        label: "start of your Beginning Phase: kill a unit you control here to draw 1",
        targets: [{
          bind: "t", spec: { type: "unit", friendly: true, here: true },
          prompt: "Kill which of your units here to draw 1?",
        }],
        program: [
          { op: "kill", to: "$t", credit: false },
          { op: "draw", n: 1 },
        ],
      }],
    },

    "Star Spring": {
      triggers: [{
        on: "played", controllerFromEvent: true, optional: true,
        oncePerTurn: true, perPlayer: true,
        label: "first non-token unit played here each turn: send another unit here home",
        condSpec: {
          k: "and",
          conds: [
            { k: "evType", type: "unit" },
            { k: "not", cond: { k: "evToken" } },
            { k: "evAtSelfBf" },
          ],
        },
        targets: [{
          bind: "t", spec: { type: "unit", friendly: true, here: true, notEv: true },
          prompt: "Move which other unit you control here to its base?",
        }],
        program: [{ op: "move", to: "$t", dest: "base" }],
      }],
    },

    "Vaults of Helia": {
      triggers: [{
        on: "hold", selfBf: true, you: true,
        label: "hold here: your non-token units cost 1 more this turn",
        program: [{ op: "nextPlayMod", cardType: "unit", mod: "costMore", n: 1, persist: true }],
      }],
    },
  });
})();
